"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initStore = void 0;
const store_1 = require("@/state/store");
const landingPageContainerID = "LandingPageMediaComponentWrapper"; // -> defined in landingpagemediacomponent.jsp
const langingPageHeaderTextID = "LandingPageHeaderContent"; // -> defined in loginRegistrationForm.jsp and RegistrationForm.jsp
const initStore = (rootContainerID) => {
    const rootContainerData = readRootContainerDataAttr(rootContainerID);
    store_1.store.isLastStepPage = rootContainerData.isLastStepPage;
    store_1.store.username = rootContainerData.username;
    store_1.store.oAuthSignIn = rootContainerData.oAuthSignIn;
    const landingPageData = readLandingpageDataAttr(landingPageContainerID);
    store_1.store.isLandingPage = landingPageData.isLandingPage;
    store_1.store.landingPage.hasHiResImage = landingPageData.landingPageHasHiResImage;
    store_1.store.landingPage.desktopImageURL = landingPageData.landingPageDesktopImageURL;
    store_1.store.landingPage.tabletImageURL = landingPageData.landingPageTabletImageURL;
    store_1.store.landingPage.mobileImageURL = landingPageData.landingPageMobileImageURL;
    store_1.store.landingPage.imageAltText = landingPageData.landingPageImageAltText;
    store_1.store.landingPage.headerText = extractLandingpageHeaderText(langingPageHeaderTextID);
};
exports.initStore = initStore;
function readRootContainerDataAttr(rootContainerID) {
    var _a;
    const wrapperElement = (_a = document
        .getElementById(rootContainerID)) === null || _a === void 0 ? void 0 : _a.closest("[data-mfloginwrapper]");
    const username = (wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.dataset.username) || "";
    const isLastStepPage = (wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.dataset.islaststeppage) === "true";
    const oAuthSignIn = (wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.dataset.oauthsignin) || "";
    return {
        username,
        isLastStepPage,
        oAuthSignIn,
    };
}
function readLandingpageDataAttr(landingPageContainerID) {
    const landingPageImageData = document.getElementById(landingPageContainerID);
    const isLandingPage = !!landingPageImageData;
    let landingPageHasHiResImage = false;
    let landingPageDesktopImageURL = "";
    let landingPageTabletImageURL = "";
    let landingPageMobileImageURL = "";
    let landingPageImageAltText = "";
    if (landingPageImageData) {
        if (landingPageImageData.dataset["landingPageImage"]) {
            const image = landingPageImageData.dataset["landingPageImage"];
            landingPageHasHiResImage = true;
            landingPageDesktopImageURL = `${image}?width=1000&height=600&fit=crop&format=auto 1x, ${image}?width=2000&height=1200&fit=crop&format=auto 2x`; // Aspect ratio 5:3
            landingPageTabletImageURL = `${image}?width=800&height=360&fit=crop&format=auto 1x, ${image}?width=1600&height=720&fit=crop&format=auto 2x`; // Aspect ratio 20:9
            landingPageMobileImageURL = `${image}?width=400&height=180&fit=crop&format=auto 1x, ${image}?width=800&height=360&fit=crop&format=auto 2x`; // Aspect ratio 20:9
            landingPageImageAltText = landingPageImageData.dataset["landingPageAltText"] || "";
        }
        else {
            landingPageHasHiResImage = false;
            landingPageDesktopImageURL = landingPageImageData.dataset["desktopImage"] || "";
            landingPageTabletImageURL = landingPageImageData.dataset["mobileImage"] || "";
            landingPageMobileImageURL = landingPageImageData.dataset["mobileImage"] || "";
            landingPageImageAltText = landingPageImageData.dataset["desktopAltText"] || "";
        }
    }
    return {
        isLandingPage,
        landingPageHasHiResImage,
        landingPageDesktopImageURL,
        landingPageTabletImageURL,
        landingPageMobileImageURL,
        landingPageImageAltText,
    };
}
function extractLandingpageHeaderText(landingPageHeaderContentID) {
    var _a;
    const headerContent = document.getElementById(landingPageHeaderContentID);
    let landingPageHeaderText = "";
    if (headerContent) {
        landingPageHeaderText = ((_a = headerContent.querySelector("h2")) === null || _a === void 0 ? void 0 : _a.textContent) || "";
    }
    return landingPageHeaderText;
}
